import { DecisionEnvironment } from "src/api/types";
import { ANY_FOLDER, Capabilities } from "src/hooks/useCapabilities/types";

export const readableEnvironments = (
  decisionHistory: Capabilities["decisionHistory"],
): DecisionEnvironment[] => [
  ...(decisionHistory.canReadLive(ANY_FOLDER)
    ? [DecisionEnvironment.LIVE]
    : []),
  ...(decisionHistory.canReadSandbox(ANY_FOLDER)
    ? [DecisionEnvironment.SANDBOX]
    : []),
];

export const clampEnvironment = (
  readable: DecisionEnvironment[],
  wanted: DecisionEnvironment | null | undefined,
): DecisionEnvironment | undefined =>
  wanted && readable.includes(wanted) ? wanted : readable[0];
